import Simplebar from 'simplebar';

const instances = [];
const init = () => {
  const targetElms = document.getElementsByClassName('js-simplebar');
  if(targetElms.length == 0) return;
  for(const targetElm of targetElms) {
    instances.push(new Simplebar(targetElm));
  }
}

const resize = () => {
  for(const instance of instances) {
    instance.recalculate();
  }
}

export {
  init,
  resize
}